export default __webpack_public_path__ + "static/social_preview-a2c048d742da6b1dfb5b05e92779303e.png";